// extracted by mini-css-extract-plugin
export default {"titles":"SuccessFragment_titles__BPs8G","iconFrame":"SuccessFragment_iconFrame__qH2eN"};